<template>
  <div>
    <ul>
      <li v-for="item in strageData" :key="item.id">
        <div class="strage_time">{{item.publishDate}}</div>
        <div class="content_wrapper">
          <div class="strage_content">
            <div class="strage_title">
              <div class="title_left" @click="goDetail(item.id)">{{item.title}}</div>
              <div class="title_right">
                <div class="like" @click="handleClick(item.id)">
                   <img :ref="item.id + 'img'" src="~assets/images/like01.png" alt="">
            
                </div>
                <div class="number" :ref="item.id">{{item.totalLikes}}</div>
              </div>
            </div>
            <div class="strage_detail" @click="goDetail(item.id)" v-html="item.description"></div>
          </div>
          <div class="strage_bottom">
            <div class="bottom_left" @click="goAnaDetail(item.analystId)">
              <img src="~assets/images/analyst.png" alt />
              {{item.analystName}}
            </div>
            <div class="bottom_right">
              <ul>
                <li class="item1" @click="goTrade(item.productCode)">{{item.productName}}</li>
                <li :class="[{'red':item.pro == 'red'},{'green':item.pro == 'green'}]">{{item.tendency | filterTrend}}</li>
              </ul>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="load_more" @click="loadMore('more')">点击加载更多</div>
  </div>
</template>

<script>
import { toast } from "assets/commonjs/toast";
import { getStore, setStore } from "assets/commonjs/storage";

import user from "assets/commonjs/userInfo";
export default {
  data() {
    return {
      count: 1,
      companyId: 1,
      productCode: "",
      tradeUrl: process.env.VUE_APP_H5_TRADE,
      pc:false,
      like01:require("../../../assets/images/like01.png"),
      like02:require("../../../assets/images/like02.png"),
    };
  },
  props: ["strageData"],
  components: {
    
  },
  methods: {
    loadMore() {
      this.$emit("loadMore");
    },
    goDetail(id) {
      this.$router.push(`/app/chanceDetail/:${id}`);
    },
    goAnaDetail(id) {
      this.$router.push(`/app/analystDetail/:${id}`);
    },
    goTrade(symbol) {
       user.appGoTrade(symbol)
    },
    handleClick(id) {
      let clickedId = getStore("id_" + id);
      let status;
      if (clickedId == id) {
        //表示点击过
        status = 1;
        this.count = -1;
      } else {
        //未点击过
        status = 0;
        this.count = 1;
      }
      let data = {
        id: id,
        count: this.count,
        companyId: this.companyId
      };
      this.$api.strageList.addLike(data).then(res => {
        if (res.data && res.data.code == 0) {
          this.likeSucc(status, id);
        } else {
          toast(res.data.message);
        }
      });
    },
    likeSucc(status, id) {
      let activeEle = this.$refs[id][0];
      let activeImg = this.$refs[id +"img"][0];
      if (status == 0) {
        activeEle.innerHTML = Number(activeEle.innerHTML) + 1;
         activeImg.src = this.like02;
        setStore("id_" + id, id);
      } else if (status == 1) {
        activeEle.innerHTML = Number(activeEle.innerHTML) - 1;
         activeImg.src = this.like01
        setStore("id_" + id, "");
      }
    },
    clearIdStorage() {
      let keyArr = [];
      for (var i = 0; i < localStorage.length; i++) {
        keyArr.push(localStorage.key(i));
      }
      let idArr = keyArr.filter(item => item.startsWith("id"));
      for (var j = 0; j < idArr.length; j++) {
        localStorage.removeItem(idArr[j]);
      }
    }
  },
  filters: {
    filterTrend(val) {
      if (val == 0) {
       return "看多";
      } else if (val == 1) {
        
         return "看空";
      }
    }
  },
  mounted() {
    this.clearIdStorage();
     if(!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)){
      this.pc = true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";
ul {
  li {
    margin-bottom: 0.3rem;
    .strage_time {
      text-align: center;
      @include sc(0.24rem, #999);
      margin-bottom: 0.2rem;
    }
    .content_wrapper {
      background: #fff;
      @include borderRadius(0.1rem);
      width: 6.9rem;
      margin: 0 auto;
      .strage_content {
        padding: 0.3rem;
        .strage_title {
          display: flex;
          justify-content: space-between;
          margin-bottom: 0.26rem;
          align-items: baseline;
          .title_left {
            @include sc(0.3rem, #333);
            font-weight: bold;
            word-wrap: break-word;
            word-break: break-all;
            overflow: hidden;
            width: 5rem;
            line-height: 0.5rem;
          }
          .title_right {
            @include fj();
            @include sc(0.24rem, #666);
            .like {
              position: relative;
            }
          }
        }
        .strage_detail {
          @include sc(0.28rem, #666);
          line-height: 0.36rem;
          word-wrap: break-word;
          word-break: break-all;
          overflow: hidden;
        }
      }
    }
    .strage_bottom {
      display: flex;
      justify-content: space-between;
      padding: 0.1rem 0.3rem;
      border-top: 0.025rem solid #ebebeb;
      .bottom_left {
        @include sc(0.24rem, #485266);
        img {
          @include wh(0.6rem, 0.6rem);
          vertical-align: middle;
          margin-right: 0.1rem;
        }
      }
      .bottom_right {
        ul {
          display: flex;

          li {
            background: rgba(246, 247, 251, 1);
            @include borderRadius(0.06rem);
            @include sc(0.24rem, #0a95ff);
            text-align: center;
            padding: 0.08rem 0.2rem;
            margin-bottom: 0;
          }
           li.red{
            color: #fb605a
          }
          li.green{
            color: #51b64c
          }
          li.item1 {
            margin-right: 0.1rem;
          }
        }
      }
    }
  }
}
.load_more {
  @include sc(0.3rem, #333);
  text-align: center;
  margin-top: 0.3rem;
}
.like {
  img{
    width:.27rem;
    margin-right:.2rem;
 }
}
</style>